<template>
  <div id="app" class="app-shell" :class="{ 'sidenav-open': sidenavOpen }">
    <a href="#main-content" class="skip-link">پرش به محتوای اصلی</a>

    <app-status-bar />
    <toast-host />

    <side-nav />

    <div class="flexible-content">
      <navbar :page="activePage" />

      <new-message-alert />

      <main id="main-content" tabindex="-1">
        <router-view />
      </main>

      <app-footer />
    </div>
  </div>
</template>

<script>
import SideNav from "./components/SideNav.vue";
import Navbar from "./components/Navbar.vue";
import AppFooter from "./components/Footer.vue";
import AppStatusBar from "./components/pwa/AppStatusBar.vue";
import ToastHost from "./components/pwa/ToastHost.vue";
import NewMessageAlert from "./components/pwa/NewMessageAlert.vue";

const DEFAULT_TITLE = "داشبرد برنامه نویسان دانش برتر سهند";

export default {
  name: "App",
  components: {
    SideNav,
    Navbar,
    AppFooter,
    AppStatusBar,
    ToastHost,
    NewMessageAlert,
  },
  data() {
    return {
      activePage: DEFAULT_TITLE,
    };
  },
  computed: {
    sidenavOpen() {
      return this.$store.state.sidenav;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(route, prev) {
        const title = (route && route.meta && route.meta.title) || "";
        this.activePage = title || DEFAULT_TITLE;
        // عنوان تب مرورگر هم با صفحه‌ی جاری هماهنگ شود
        document.title = title ? `${title} | ${DEFAULT_TITLE}` : DEFAULT_TITLE;

        // پس از هر ناوبری (نه بارگذاری اول) فوکوس را به محتوای اصلی ببر تا
        // کاربر کیبورد/اسکرین‌ریدر داخل محتوای جدید قرار بگیرد، نه گیر در منو.
        if (prev) {
          this.$nextTick(() => {
            const el = document.getElementById("main-content");
            if (el) el.focus();
          });
        }
      },
    },
  },
};
</script>

<style>
:root {
  --bndbs-sidenav-w: 250px;
}

.app-shell {
  min-height: 100vh;
}

/* محتوای اصلی کنار sidenav (RTL → sidenav سمت راست، پس فاصله از سمت آغاز خط) */
.flexible-content {
  transition: padding-inline-start 0.25s ease;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

@media (min-width: 1200px) {
  .app-shell.sidenav-open .flexible-content {
    padding-inline-start: var(--bndbs-sidenav-w);
  }
}

main {
  flex: 1 0 auto;
  min-height: 80vh;
}

/* فوکوس برنامه‌ای روی <main> پس از ناوبری نباید کادر بصری بزرگ نشان دهد */
main:focus {
  outline: none;
}

/* پیوند «پرش به محتوا» — تا وقتی فوکوس نگیرد پنهان است */
.skip-link {
  position: fixed;
  top: 0;
  inset-inline-start: 0;
  z-index: 100010;
  background: #1b1f2a;
  color: #fff;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  border-block-end: 3px solid #f35b21;
  border-end-end-radius: 8px;
  transform: translateY(-130%);
  transition: transform 0.15s ease;
}
.skip-link:focus {
  transform: translateY(0);
  outline: 2px solid #fff;
  outline-offset: -6px;
}
@media (prefers-reduced-motion: reduce) {
  .skip-link {
    transition: none;
  }
}

/* روی همه‌ی صفحه‌ها یک عرض بیشینه‌ی معقول */
main > .container-fluid {
  max-width: 1320px;
  margin-inline: auto;
}

.vpd-input-group input {
  width: 100%;
}
.vpd-input-group {
  width: 100%;
}
</style>
